import axios from 'axios/index';
import { DELETE_USER } from '../../utils/constants';

const deleteUser = async (hash, id) => {

    return await axios.delete(DELETE_USER(id),
        { // <= id here
            data: {},
            headers: {
                "Accept": "application/json",
                "Accept-language": "bg",
                "Authorization": hash,
            }
        }).then(resp => {
            return resp;
        }).catch(err => {
            console.error(err)
        })
}

export default deleteUser;